<table
	mat-table
	[dataSource]="businessBaseDocxs$ | async"
	multiTemplateDataRows
	matSort
	[trackBy]="trackById"
	class="app-table animate w-full overflow-hidden rounded"
>
	<ng-container matColumnDef="title">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let element">{{ element.title }}</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
		<td mat-cell *matCellDef="let element">{{ element.type }}</td>
	</ng-container>

	<ng-container matColumnDef="lastEditedBy">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Last edited by</th>
		<td mat-cell *matCellDef="let element">
			{{ element.lastEditedBy | businessUserNameById }}
		</td>
	</ng-container>

	<ng-container matColumnDef="lastEditedOn">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Last edited on</th>
		<td mat-cell *matCellDef="let element">
			{{ element.lastEditedOn | date: 'short' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="actions">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="">
			Actions
		</th>
		<td
			mat-cell
			*matCellDef="let element"
			(click)="$event.preventDefault(); $event.stopPropagation()"
		>
			<atomic-kebab-options
				(click)="$event.preventDefault(); $event.stopPropagation()"
				[itemGroups]="[
					{
						items:
							element.id === 'default_base_docx'
								? kebabOptionsForDefaultBaseDocx
								: kebabOptions,
					},
				]"
				(onSelect)="onKebabOptionSelected($event, element)"
			></atomic-kebab-options>
		</td>
	</ng-container>

	<ng-container matColumnDef="expandedDetail">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip=""></th>
		<td
			mat-cell
			*matCellDef="let element"
			class="px-2 py-0"
			[attr.colspan]="columnsToDisplayWithExpand.length"
		>
			<div
				class="flex flex-col overflow-hidden"
				[@detailExpand]="
					element.id == expandedElement?.id ? 'expanded' : 'collapsed'
				"
			>
				<div class="p-4">
					<h5 class="mb-4">Office Variations</h5>
					<table [dataSource]="offices" mat-table class="app-table rounded">
						<ng-container matColumnDef="office">
							<th mat-header-cell *matHeaderCellDef>Office</th>
							<td mat-cell *matCellDef="let officeElement">
								{{ officeElement.officeName }}
							</td>
						</ng-container>

						<ng-container matColumnDef="fileName">
							<th mat-header-cell *matHeaderCellDef>File Name</th>
							<td mat-cell *matCellDef="let officeElement">
								<div class="flex gap-x-2 items-center">
									<span>
										{{
											element?.overrides?.office?.[officeElement.id]?.path ??
												'No file added' | fileNameFromPath
										}}</span
									>
									<ng-container
										*ngIf="element?.overrides?.office?.[officeElement.id]?.path"
									>
										<ui-button
											(click)="
												download(
													element.overrides.office[officeElement.id].path
												)
											"
											label="Download"
											[style]="'ghost'"
										></ui-button>
										<ui-button
											(click)="delete(officeElement, element)"
											color="gray"
											label="Delete"
											[style]="'solid'"
										></ui-button>
									</ng-container>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="expandableActions">
							<th mat-header-cell *matHeaderCellDef>File Actions</th>
							<td mat-cell *matCellDef="let officeElement">
								<ui-button
									(click)="fileUpload.click()"
									[style]="'outline'"
									label="Upload New"
								></ui-button>
								<input
									(change)="uploadNew($event, officeElement, element)"
									#fileUpload
									type="file"
									hidden
									accept=".docx"
								/>
							</td>
						</ng-container>
						<tr
							mat-header-row
							*matHeaderRowDef="['office', 'fileName', 'expandableActions']"
						></tr>
						<tr
							mat-row
							*matRowDef="
								let element;
								columns: ['office', 'fileName', 'expandableActions']
							"
						></tr>
					</table>
				</div>
			</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
	<tr
		mat-row
		*matRowDef="let element; columns: columnsToDisplayWithExpand"
		[class.example-expanded-row]="expandedElement === element"
		(click)="expandedElement = expandedElement === element ? null : element"
	></tr>
	<tr
		mat-row
		class="h-0"
		*matRowDef="let row; columns: ['expandedDetail']"
	></tr>
</table>
